import { render, staticRenderFns } from "./BidSubmitted.vue?vue&type=template&id=70ec18b4&scoped=true"
import script from "./BidSubmitted.vue?vue&type=script&lang=js"
export * from "./BidSubmitted.vue?vue&type=script&lang=js"
import style0 from "./BidSubmitted.vue?vue&type=style&index=0&id=70ec18b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ec18b4",
  null
  
)

export default component.exports